import React from "react"

import LazyLoad from "react-lazyload"
import loadable from "@loadable/component"

const MapComponent = loadable(() => import("../../../core/map/map.component"))

const MapBlock = ({ agenciesList }) => {
  return (
      <LazyLoad
        once
        offset={100}
        style={{width:'100%', height:'610px'}}
      >
        <MapComponent agenciesList={agenciesList} />
         </LazyLoad>
  )
}

export default MapBlock
